import axios from 'axios';

const LS_URL = 'psi_server_url';
const LS_KEY = 'psi_api_key';

export function getServerUrl() {
  return localStorage.getItem(LS_URL) || '';
}
export function getApiKey() {
  return localStorage.getItem(LS_KEY) || '';
}
export function saveConnection(url, key) {
  localStorage.setItem(LS_URL, url.replace(/\/$/, ''));
  localStorage.setItem(LS_KEY, key);
}
export function clearConnection() {
  localStorage.removeItem(LS_URL);
  localStorage.removeItem(LS_KEY);
}
export function isConnected() {
  return !!(getServerUrl() && getApiKey());
}

function createApi() {
  const base = getServerUrl() ? `${getServerUrl()}/api` : '/api';
  const instance = axios.create({ baseURL: base });
  instance.interceptors.request.use(config => {
    const key = getApiKey();
    if (key) config.headers['x-api-key'] = key;
    return config;
  });
  instance.interceptors.response.use(
    r => r.data,
    err => Promise.reject(err.response?.data?.error || err.message || 'Chyba serveru')
  );
  return instance;
}

const api = createApi();

export const ordersApi = {
  list: params => api.get('/orders', { params }),
  stats: () => api.get('/orders/stats'),
  get: id => api.get(`/orders/${id}`),
  create: data => api.post('/orders', data),
  update: (id, data) => api.patch(`/orders/${id}`, data),
  updateStatus: (id, status) => api.patch(`/orders/${id}/status`, { status }),
  delete: id => api.delete(`/orders/${id}`),
};

export const customersApi = {
  list: params => api.get('/customers', { params }),
  get: id => api.get(`/customers/${id}`),
  create: data => api.post('/customers', data),
  update: (id, data) => api.patch(`/customers/${id}`, data),
  aresLookup: ico => api.get(`/customers/ares/${ico}`),
};

export const productsApi = {
  list: params => api.get('/products', { params }),
  categories: () => api.get('/products/categories'),
  get: id => api.get(`/products/${id}`),
  create: data => api.post('/products', data),
  update: (id, data) => api.patch(`/products/${id}`, data),
  adjustStock: (id, data) => api.post(`/products/${id}/stock`, data),
  parseInvoice: formData => api.post('/products/parse-invoice', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export const invoicesApi = {
  list: params => api.get('/invoices', { params }),
  get: id => api.get(`/invoices/${id}`),
  pdfUrl: id => `${getServerUrl() || ''}/api/invoices/${id}/pdf`,
  send: id => api.post(`/invoices/${id}/send`),
  regenerate: id => api.post(`/invoices/${id}/regenerate`),
};

export const paymentsApi = {
  list: params => api.get('/payments', { params }),
  create: data => api.post('/payments', data),
  syncBank: () => api.post('/payments/sync-bank'),
  sendReminders: () => api.post('/payments/send-reminders'),
};

export const warehouseApi = {
  supplierInvoices: () => api.get('/warehouse/supplier-invoices'),
  createSupplierInvoice: formData => api.post('/warehouse/supplier-invoices', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  processSupplierInvoice: (id, items) => api.post(`/warehouse/supplier-invoices/${id}/process`, { items }),
  movements: params => api.get('/warehouse/movements', { params }),
  lowStock: () => api.get('/warehouse/low-stock'),
};

export const packingApi = {
  queue: () => api.get('/packing/queue'),
  pack: id => api.post(`/packing/${id}/pack`),
  stats: () => api.get('/packing/stats'),
};

export const shippingApi = {
  ready: () => api.get('/shipping/ready'),
  ship: (id, tracking_number) => api.post(`/shipping/${id}/ship`, { tracking_number }),
  bulkShip: shipments => api.post('/shipping/bulk-ship', { shipments }),
  generateLabels: order_ids => api.post('/shipping/czech-post/labels', { order_ids }),
};

export const facebookApi = {
  publish: data => api.post('/facebook/publish', data),
  posts: () => api.get('/facebook/posts'),
  comments: postId => api.get(`/facebook/posts/${postId}/comments`),
  parseComment: data => api.post('/facebook/parse-comment', data),
};

export const reportsApi = {
  revenue: params => api.get('/reports/revenue', { params }),
  vat: params => api.get('/reports/vat', { params }),
  products: params => api.get('/reports/products', { params }),
  exportUrl: params => {
    const qs = new URLSearchParams(params).toString();
    return `${getServerUrl() || ''}/api/reports/export?${qs}`;
  },
};

export const settingsApi = {
  get: () => api.get('/settings'),
  update: data => api.patch('/settings', data),
};

export const suppliersApi = {
  list: () => api.get('/suppliers'),
  create: data => api.post('/suppliers', data),
  update: (id, data) => api.patch(`/suppliers/${id}`, data),
};

export default api;
